import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Printer } from "lucide-react";
import { api } from "../lib/api";
import { useSite } from "../lib/site";
import { REGISTERS } from "../lib/registers";
import { Button } from "../components/ui/button";
import { BrandedLabel } from "../components/BrandedLabel";

export default function AssetLabels() {
  const [params] = useSearchParams();
  const { site } = useSite();
  const kind = params.get("kind");
  const id = params.get("id");
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/assets", { params: { kind } }).then((r) => setRows(id ? r.data.filter((a) => a.id === id) : r.data));
  }, [kind, id]);
  const cfg = REGISTERS[kind];
  return (
    <div data-testid="asset-labels-page">
      <div className="no-print mb-6 flex flex-wrap items-center justify-between gap-3">
        <div>
          <p className="eyebrow text-rose-400">{site?.name}</p>
          <h1 className="font-display text-3xl font-extrabold uppercase">{cfg?.title || "Asset"} QR labels</h1>
          <p className="text-sm text-slate-400">Print and fix to each item. Scan to open its record and start an inspection.</p>
        </div>
        <Button onClick={() => window.print()} disabled={!rows.length} className="tap bg-rose-600 hover:bg-rose-700" data-testid="print-asset-labels-btn"><Printer className="mr-2 h-4 w-4" />Print {rows.length} label{rows.length === 1 ? "" : "s"}</Button>
      </div>
      {!rows.length && <p className="text-sm text-slate-500" data-testid="asset-labels-empty">No items to print.</p>}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3 print:grid-cols-2">
        {rows.map((a) => (
          <BrandedLabel key={a.id} title={a.name} code={a.asset_code} sub={a.location || site?.name} qrValue={a.asset_code} footer="Scan me to inspect or report a fault" testid={`asset-label-${a.asset_code}`} />
        ))}
      </div>
    </div>
  );
}
